import React, {useState} from "react";
import { Container, Row, Col } from "react-bootstrap";
import Slider from "react-slick";
import $ from "jquery";
import Video01 from "../../images/video01.jpg"
import PlayVideo from "../Play/PlayVideo";
import "./VideoGallery.scss";
import ImageModule from "../../modules/image_module";

import SearchResultsImagePopup from "../SalesCard/SearchResultsImagePopup"

const VideoGallery = ({property_data, layout_type}) => {

    const [photoIndex, setPhotoIndex] = useState(0);
    const [isOpen, setIsOpen] = useState(false);

    const openLighboxMobile = (e, ind) => {
        e.preventDefault();
        setPhotoIndex(ind);
        setIsOpen(true);
    } 

    var settings = {
        dots: false,
        arrows: true,
        infinite: false,
        autoplay:true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        mobileFirst: true,
        afterChange: (event) => {
            var activeDotEl = $('.video-gallery .slick-slider').find('.slick-dots').find('li.slick-active');
            if(activeDotEl.get(0)){
                activeDotEl.get(0).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            }
        },
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    dots: true,
                    arrows: false,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    dots: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                },
            },
           
        ],
    };

    let [isPlay, setPlay] = React.useState(false);

    const ImageRenderList = ({item, image_url, imagename}) => {
        let processedImages = JSON.stringify({});
        if (item?.imagetransforms?.images_Transforms) {
            processedImages = item?.imagetransforms?.images_Transforms;
        }
        return (
          <ImageModule ImageSrc={image_url} title={item.display_address} altText={item.display_address} imagetransforms={processedImages} ggfx_results={item?.ggfx_results} renderer="srcSet" imagename={imagename} strapi_id={item.id} />                           
        )
    }

    let image_name = "new-developments.images.slider_image"

    if(layout_type === "page_layout"){
        image_name = "pages.gallery_component_images.slider_image"
    }
    if(layout_type === "areaguide_layout"){
        image_name = "area-guides.gallery_image.slider_image"
    }

    return (
        <React.Fragment>
            {property_data?.images && property_data?.images?.length > 0 && 
            <section className="video-gallery" id="video">
                <Container>
                    <Row>
                        <Col>
                            {property_data?.gallery_title && <h2>{property_data?.gallery_title}</h2>}
                            {/* <h2>Video & Image Gallery</h2> */}
                            <Slider {...settings}>
                                {
                                    property_data?.images?.map((item, index) => {
                                        return(
                                            // <div className="gallery" onClick={(e) => openLighboxMobile(e,index)}>
                                            //     <img src={item.srcUrl} alt={property_data.display_address} />
                                            // </div>

                                            <div className="gallery" >
                                                {property_data?.video_tour?.length > 0 && index === 0 &&
                                                <button className="video-wrap" onClick={e => { setPlay(true) }}>
                                                    <i className="icon-video"></i>
                                                </button>}
                                                {/* <img src={item.srcUrl} alt={property_data.display_address} onClick={(e) => openLighboxMobile(e,index)} /> */}

                                                <ImageRenderList item={property_data} image_url={item} imagename={image_name}  />
                                            </div>
                                        )
                                    })
                                    
                                }
                            </Slider>
                        </Col>
                    </Row>
                </Container>
            </section>
            }
            
            <PlayVideo
                isOpen={isPlay}
                isCloseFunction={setPlay}
                videoId={property_data?.video_tour?.length > 0 && property_data?.video_tour[0]?.url}
                isAutoPlay={1}
            />

            {/* {isOpen && (property_data?.images && property_data?.images?.length != 0) && (
                <SearchResultsImagePopup
                    propertyId = {property_data.id}
                    propertyImage = {property_data?.images}
                    photoIndex={photoIndex}
                    isOpen={isOpen}
                    setIsOpen={setIsOpen}
                    img_type = {"no_property"}
                />
            )} */}
        </React.Fragment>
    );
};
export default VideoGallery;
